class CSSUtility {

  constructor() {
    this.loadedPaths = [];
  }

  loadCSS(path) {

    if (this.loadedPaths.includes(path)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = path;
    document.head.appendChild(link);

    this.loadedPaths.push(path);

    return link;

  }

}

export default CSSUtility;